import React from 'react';
import Icon from '../../../components/AppIcon';

const PressReleasePreview = ({ formData }) => {
  const currentDate = new Date()?.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const hasRequiredData = formData?.surgeonName && formData?.practiceName && formData?.city && formData?.state;

  return (
    <div className="bg-card border border-border rounded-lg p-6 md:p-8 shadow-sm">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
          <Icon name="Eye" size={20} color="var(--color-accent)" />
        </div>
        <div>
          <h2 className="text-xl md:text-2xl font-semibold text-foreground">Live Preview</h2>
          <p className="text-sm text-muted-foreground font-caption">Real-time press release preview</p>
        </div>
      </div>
      <div className="bg-background border border-border rounded-lg p-6 md:p-8 space-y-6 font-body">
        {!hasRequiredData ? (
          <div className="text-center py-12">
            <Icon name="FileText" size={48} className="mx-auto mb-4 text-muted-foreground" />
            <p className="text-muted-foreground">Fill in the form to see your press release preview</p>
          </div>
        ) : (
          <>
            <div className="space-y-4">
              <p className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
                {formData?.city || '[CITY]'}, {formData?.state || '[STATE]'}
              </p>
              <h1 className="text-2xl md:text-3xl font-bold text-foreground text-center">
                The Surgical Detail Most Patients Never Hear About—Until Now
              </h1>
              <h2 className="text-lg md:text-xl font-semibold text-foreground text-center mt-2">
                {formData?.surgeonName || '[DOCTOR NAME]'} Implements Advanced Videra System to Enhance Surgical Precision and Patient Outcomes
              </h2>
            </div>

            <div className="text-center border-b border-border pb-6">
              <p className="text-sm font-medium text-muted-foreground mb-2">FOR IMMEDIATE RELEASE</p>
              <p className="text-sm text-muted-foreground">{currentDate}</p>
            </div>

            <div className="space-y-4 text-foreground leading-relaxed">
              <p>
                {formData?.practiceName || '[PRACTICE NAME]'}, led by Dr. {formData?.surgeonName || '[DOCTOR NAME, CREDENTIALS]'}, is now offering VeraForm®, an FDA-cleared three-dimensional tissue marker developed by Videra Surgical, as an option for patients undergoing breast cancer surgery.
              </p>

              <p>
                While most patients focus on the tumor removal itself, surgeons must also consider how the surgical site will be identified on future imaging and during post-operative planning. VeraForm® is designed to provide a continuous, three-dimensional, radiopaque marker that identifies the surgical site after the procedure is complete.
              </p>

              {formData?.quote && (
                <blockquote className="border-l-4 border-primary pl-6 py-2 my-6 italic bg-muted/30 rounded-r-lg">
                  <p className="text-foreground mb-2">"{formData?.quote}"</p>
                </blockquote>
              )}

              <p>
                VeraForm® is placed at the time of surgery and is visible across standard imaging modalities. Unlike traditional point markers or clips, the device is designed to create a continuous reference of the surgical site, which may assist care teams during post-surgical imaging review and radiation planning, when applicable.
              </p>

              <p>
                Dr. {formData?.surgeonName || '[DOCTOR NAME]'} and the team at {formData?.practiceName || '[PRACTICE NAME]'} will discuss whether VeraForm® is appropriate during individualized patient consultations, based on surgical approach and overall treatment planning.
              </p>
            </div>

            <div className="border-t border-border pt-6 space-y-3">
              <p className="text-center text-muted-foreground">________________</p>
              <h3 className="text-lg font-semibold text-foreground">About VeraForm®</h3>
              <p className="text-foreground leading-relaxed">
                VeraForm® is an FDA 510(k)-cleared tissue marker developed by Videra Surgical. The device is designed to provide a permanent, continuous, three-dimensional radiopaque mark of a surgical site to support post-operative imaging and planning. VeraForm® is intended to complement surgical technique and clinical judgment.
              </p>
            </div>

            <div className="border-t border-border pt-6 space-y-3">
              <h3 className="text-lg font-semibold text-foreground">About {formData?.practiceName || '[PRACTICE NAME]'}</h3>
              <p className="text-foreground leading-relaxed">
                {formData?.practiceName || '[PRACTICE NAME]'} is a {formData?.practiceDescription || '[brief, standard practice description if desired]'} committed to evidence-based care, patient education, and thoughtful adoption of surgical technologies.
              </p>
            </div>

            {(formData?.contactName || formData?.contactEmail || formData?.contactPhone) && (
              <div className="border-t border-border pt-6 space-y-2">
                <p className="text-center text-muted-foreground">________________</p>
                <h3 className="text-lg font-semibold text-foreground mb-3">Media Contact</h3>
                {formData?.contactName && (
                  <p className="text-foreground">{formData?.contactName}</p>
                )}
                {formData?.contactTitle && (
                  <p className="text-foreground">{formData?.contactTitle}</p>
                )}
                {formData?.contactPhone && (
                  <p className="text-foreground">{formData?.contactPhone}</p>
                )}
                {formData?.contactEmail && (
                  <p className="text-foreground">{formData?.contactEmail}</p>
                )}
                {formData?.website && (
                  <p className="text-foreground">{formData?.website}</p>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PressReleasePreview;